import type { Components, Theme } from '@mui/material/styles';

export const componentOverrides: Components<Theme> = {
  MuiAppBar: {
    styleOverrides: {
      root: ({ theme }) => ({
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
      }),
    },
  },
  MuiButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        textTransform: 'none',
        fontWeight: theme.typography.fontWeightMedium,
      }),
    },
    defaultProps: {
      disableElevation: true,
    },
  },
  MuiTextField: {
    defaultProps: {
      size: 'small',
      variant: 'outlined',
    },
  },
  MuiIconButton: {
    styleOverrides: {
      root: {
        '&:focus-visible': {
          opacity: 1,
        },
      },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      root: {
        flexShrink: 0,
      },
      paper: {
        position: 'unset',
        height: 'calc(100vh - 140px)',
        boxSizing: 'border-box',
        padding: '20px',
        marginTop: '60px',
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: 4,
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      head: ({ theme }) => ({
        fontWeight: theme.typography.fontWeightBold,
        fontSize: '0.75rem',
      }),
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: ({ theme }) => ({
        '&:last-child td': {
          borderBottom: 0,
        },
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        },
      }),
    },
  },
};
